<div class="row" *ngFor="let graph of graphs">
  <app-basic-cartesian-chart
    [config]="graph"
    [startDateOverride]="fromDate"
    [endDateOverride]="toDate"
  ></app-basic-cartesian-chart>
</div>
